export default "__VITE_ASSET__CExS3x$B__"